import styles from './style.module.scss'
import PropTypes from 'prop-types'
import { useQuery } from '@apollo/client'
import { GET_WAGON_WHEEL_DATA } from '@graphql/wagonWheel/wagonWheel.query'
import { useEffect, useState } from 'react'
import { getRun, getXaxis, renderNewCords } from '@shared/libs/wagonGraph'
import WagonWheelChart from '@shared/components/graphs/wagonWheel/wagonWheelChart'

const SpiderBatterData = ({ data, matchId, currentTeam }) => {
  const { data: playerStats } = useQuery(GET_WAGON_WHEEL_DATA, {
    variables: {
      input: {
        iBatterIds: [data?.iBatterId],
        iMatchId: matchId,
        nInningNumber: currentTeam
      }
    }
  })

  const [newData, setNewData] = useState([])

  useEffect(() => {
    if (playerStats?.getWagonsData?.runs?.types?.length > 0) {
      handleData(playerStats?.getWagonsData?.runs)
    }
  }, [playerStats])

  // !HANDLE DATA TYPE WISE
  function handleData(d) {
    const t = mapNewData(d?.types)
    setNewData(t)
  }

  // const totalBallFaced = data?.nBallFaced
  // const dotBalls = data?.nDots
  // const singles = playerStats?.getWagonsData?.runs?.types?.find(d => d?.type === '1s')?.count || 0
  // const doubles = playerStats?.getWagonsData?.runs?.types?.find(d => d?.type === '2s')?.count || 0
  // const triples = playerStats?.getWagonsData?.runs?.types?.find(d => d?.type === '3s')?.count || 0
  // const fours = playerStats?.getWagonsData?.runs?.types?.find(d => d?.type === '4s')?.count || 0
  // const sixes = playerStats?.getWagonsData?.runs?.types?.find(d => d?.type === '6s')?.count || 0

  // const totalRuns = singles * 1 + doubles * 2 + triples * 3 + fours * 4 + sixes * 6
  // const boundaryPercentage = totalBallFaced ? (((fours * 4 + sixes * 6) / totalRuns) * 100).toFixed(2) : 0
  // const boundaryFrequency = totalBallFaced ? ((fours * 4 + sixes * 6) / totalRuns).toFixed(2) : 0
  // const dotBallPercentage = totalBallFaced ? ((dotBalls / totalBallFaced) * 100).toFixed(2) : 0
  // const dotBallFrequency = totalBallFaced ? (dotBalls / totalBallFaced).toFixed(2) : 0
  // const strikeRate = totalBallFaced ? ((totalRuns / totalBallFaced) * 100).toFixed(2) : 0

  // !CHANGE X AND Y CORDS AS PER ENTITY CORDS
  function mapNewData(d) {
    const t = d?.map(d => {
      return {
        ...d,
        list: d?.list?.map(t => {
          const newCords = renderNewCords(getXaxis(t?.nXcord, getRun[d?.type]), t?.nYcord)
          return {
            x: newCords?.x,
            y: newCords?.y
          }
        })
      }
    })
    return t
  }

  return (
    <div className={`${styles.dataLayout}`}>
      {/* <div className="d-flex flex-column justify-content-center align-items-center px-2">
        <div className={styles.performance}>
          <div className="d-flex flex-row justify-content-between align-items-center">
            <div className={styles.dataColumn}>
              <span>BDRY%</span>
              <span className={styles.value}>{boundaryPercentage}</span>
            </div>
            <div className={`${styles.dataColumn} mx-5`}>
              <span>BDRY Freq.</span>
              <span className={styles.value}>{boundaryFrequency}</span>
            </div>
            <div className={`${styles.dataColumn}`}>
              <span>Dot Balls</span>
              <span className={styles.value}>{dotBalls || ''}</span>
            </div>
          </div>
          <div className={styles.line}></div>
          <div className="d-flex flex-row justify-content-between align-items-center">
            <div className={styles.dataColumn}>
              <span>DB %</span>
              <span className={styles.value}>{dotBallPercentage || ''}</span>
            </div>
            <div className={styles.dataColumn}>
              <span>DB Freq.</span>
              <span className={styles.value}>{dotBallFrequency}</span>
            </div>
            <div className={styles.dataColumn}>
              <span>Strike Rate</span>
              <span className={styles.value}>{strikeRate}</span>
            </div>
          </div>
        </div>
        <div className={`${styles.capsules} mt-4`}>
          <div className={` ${styles.capsule} ${styles.capsuleAll}`}>
            <span>All</span>
            <div className={styles.line}></div>
            <span>{totalRuns || 0}</span>
          </div>
          <div className={` ${styles.capsule} ${styles.capsule1}`}>
            <span>1s</span>
            <div className={styles.line}></div>
            <span>{singles || 0}</span>
          </div>
          <div className={`${styles.capsule} ${styles.capsule2}`}>
            <span>2s</span>
            <div className={styles.line}></div>
            <span>{doubles || 0}</span>
          </div>
          <div className={` ${styles.capsule} ${styles.capsule3}`}>
            <span>3s</span>
            <div className={styles.line}></div>
            <span>{triples || 0}</span>
          </div>
          <div className={`${styles.capsule} ${styles.capsule4}`}>
            <span>4s</span>
            <div className={styles.line}></div>
            <span>{fours || 0}</span>
          </div>
          <div className={`${styles.capsule} ${styles.capsule6}`}>
            <span>6s</span>
            <div className={styles.line}></div>
            <span>{sixes || 0}</span>
          </div>
        </div>
      </div> */}
      {playerStats?.getWagonsData?.isCoordinate && (
        <div className={`${styles.chartContainer} position-relative`}>
          <WagonWheelChart data={newData} isScorecard />
        </div>
      )}
      <div className={styles.totalScore}>
        <span>Total Score : {data?.nRuns || '-'} ({data?.nBallFaced || '-'})</span>
      </div>
    </div>
  )
}

SpiderBatterData.propTypes = {
  data: PropTypes.object,
  matchId: PropTypes.string,
  currentTeam: PropTypes.number
}

export default SpiderBatterData
